import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Dialer from "@/services/dialer/dialer";
import type { CreateDialerSession, CreateDialerSessionResult } from "@/dtos/Dialer.dto";

export function useCreateDialerSession() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: CreateDialerSession): Promise<CreateDialerSessionResult> => {
      const result = await Dialer.createSession(data);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to start dialer session");
      }
      return result.data.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["dialerSession", "active"] });
    },
  });
}
